import React from "react";
import { FullSearch } from "../../components/FullSearch";
import { PlansSlider } from "../../components/PlansSlider";
import { StaticBanner } from "../../components/StaticBanner";
import { ContactSection } from "../sections/ContactSection";
import { HelpSection } from "../sections/HelpSection";
import { VideoSection } from "../sections/VideoSection";
import styles from "./styles";
export const LandingPage = () => {
  const classes = styles();
  return (
    <div className={classes.mainContainer}>
      <div>
        <StaticBanner />
      </div>
      <div>
        <FullSearch />
      </div>
      <div className={classes.sectionContainer}>
        <div className={classes.sectionText}>
          Los Planes de Saludsa tienen beneficios exclusivos y servicios que se
          encuentran incluidos en tu cobertura
        </div>
      </div>
      <div>
        <div className={classes.titleSlider}>Escoge el Plan que tienes</div>

        <PlansSlider />
      </div>
      <div>
        <HelpSection />
      </div>
      <div>
        <VideoSection />
      </div>
      <div>
        <ContactSection />
      </div>
    </div>
  );
};
